// todo: minPx and maxPix is used in picture component
export const minPx = {
  ultra: 2560,
  xxlarge: 1920,
  xlarge: 1440,
  large: 1024,
  medium: 768
}

export const maxPx = {
  ultra: 2560,
  xxlarge: 1920,
  large: 1439,
  medium: 1023,
  small: 767
}

export const min = (breakpoints) => ({
  ultra: `(min-width: ${breakpoints.ultra.width}px)`,
  xxlarge: `(min-width: ${breakpoints.xxlarge.width}px)`,
  xlarge: `(min-width: ${breakpoints.xlarge.width}px)`,
  large: `(min-width: ${breakpoints.large.width}px)`,
  medium: `(min-width: ${breakpoints.medium.width}px)`
})

export const max = (breakpoints) => ({
  ultra: `(max-width: ${breakpoints.ultra.width}px)`,
  xxlarge: `(max-width: ${breakpoints.xxlarge.width - 1}px)`,
  large: `(max-width: ${breakpoints.xlarge.width - 1}px)`,
  medium: `(max-width: ${breakpoints.large.width - 1}px)`,
  small: `(max-width: ${breakpoints.medium.width - 1}px)`
})

export default {
  min,
  max,
  minPx,
  maxPx
}
